import { type FC, type ReactNode } from "react";
import { Link } from "react-router-dom";

import { css, type CSSObject } from "@emotion/css";
import { Fonts } from "@snapchat/snap-design-system";

interface TabLinkProps {
    to: string;
    relative?: "path" | "route";
    children: ReactNode;
}

const { color, ...headingNoColorCss } = Fonts.Heading.H500;

export const TabLink: FC<TabLinkProps> = ({ to, relative, children }) => (
    <Link to={to} {...(relative && { relative })} className={linkStyle}>
        {children}
    </Link>
);

const linkStyle = css`
    margin-bottom: -2px;
    padding: 15px 8px;
    color: inherit;
    ${headingNoColorCss as CSSObject};
    text-decoration: none;

    &:hover {
        color: inherit;
    }
`;
